import { render, staticRenderFns } from "./TemporaryPriceCalculator.vue?vue&type=template&id=0bc628a6"
import script from "./TemporaryPriceCalculator.vue?vue&type=script&lang=ts"
export * from "./TemporaryPriceCalculator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports